import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchSourceOverview } from '@/slices/functionSlice';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

function Summary({ overview, fetchSourceOverview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  const items = [
    {
      title: 'Source 个数',
      info: (
        <>
          <CountUp end={overview.activeSourceNum} duration={0.4} />/
          <CountUp end={overview.totalSourceNum} duration={0.4} />
        </>
      ),
      icon: 'other2',
      unit: '个',
    },
    {
      title: 'Source 实例数',
      info: <CountUp end={overview.sourceInstanceNum} duration={0.4} />,
      icon: 'other3',
      unit: '个',
    },
    {
      title: 'Source 异常数',
      icon: 'other4',
      info: <CountUp end={overview.sourceExceptionNum} duration={0.4} />,
      unit: '个',
    },
  ];

  useEffect(() => {
    if (clusterName) {
      fetchSourceOverview(clusterName);
    }
  }, [clusterName, fetchSourceOverview]);

  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.function.sourceoverview,
    loading: state.function.loading,
  }),
  {
    fetchSourceOverview,
  },
)(Summary);
